import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Refresh.svg?component
var Refresh_exports = /* @__PURE__ */ __exportAll({
	default: () => Refresh_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "none",
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M5.25 14.248v4.5H.75m18-9v-4.5h4.5m-4.218-.003A9.752 9.752 0 0 1 8.246 21m-3.279-2.249A9.753 9.753 0 0 1 15.754 3"
	}, null, -1)])]);
}
var Refresh_default = { render: render$1 };
//#endregion
export { Refresh_exports, Refresh_default as default, render$1 as render };

//# sourceMappingURL=Refresh.svg_component.js.map